<template>
  <div class="ability">
    <img class="ability-img" src="/images/guideline/ability_model0.jpg" alt="">
    <img class="ability-img" src="/images/guideline/ability_model1.jpg" alt="">
    <img class="ability-img" src="/images/guideline/ability_model2.jpg" alt="">
    <img class="ability-img" src="/images/guideline/ability_model3.jpg" alt="">
    <div v-if="contextId" class="btn" @click="toPkg">
      <img src="/images/guideline/ability_btn.png" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Config } from "@/utils";
export default {
  data() {
    return {
      contextId: null
    };
  },
  created() {
    if (this.isNative) {
      this.$store.dispatch("externalInterface/getContextId").then(e => {
        this.contextId = e.data;
      });
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function(route) {
        if(this.isNative){
          return
        }
        this.contextId = route.query.contextId || null;
        let params = this.contextId ? `&contextId=${this.contextId}` : "";
        this.$setShareConfig({
          desc: `培育优秀孩子，成就幸福家庭，欢迎您体验智伴优学！`,
          title: `智伴优学4+4儿童能力发展体系`,
          imgUrl: process.env.VUE_APP_SHARE_URL + Config.SHARE_IMAGE_URL,
          link:
            `${
              process.env.VUE_APP_SHARE_URL
            }/share.html?path=${encodeURIComponent(this.$route.path)}` + params
        });
      }
    }
  },
  methods: {
    toPkg() {
      this.$router.push({
        path: "/goods/pkg",
        query: { contextId: this.contextId }
      });
    }
  },
  computed: {
    ...mapGetters({
      isNative: "externalInterface/isNative"
    })
  }
};
</script>

<style scoped>
.ability {
  position: relative;
}
.ability .btn {
  position: absolute;
  bottom: 0;
}
.ability .btn img {
  width: 100vw;
  display: block;
}
.ability-img {
  width: 100vw;
  display: block;
}
</style>
